// extracted by mini-css-extract-plugin
export var container = "iconCollection-module--container--19697";
export var linkContainer = "iconCollection-module--linkContainer--10703";
export var scroll = "iconCollection-module--scroll--b4a51";
export var slider = "iconCollection-module--slider--b4c27";
export var sliderTrack = "iconCollection-module--sliderTrack--da334";